import type { Product } from '@/lib/types/Product'

const cache = new Map()

export async function loadProducts(
  dispenserTypes: string[],
): Promise<Product[]> {
  const cacheKey = dispenserTypes.join(',')
  if (cache.get(cacheKey)) {
    return cache.get(cacheKey)
  }
  const query = new URLSearchParams()
  query.set('view', 'json-endpoint')
  for (const dispenserType of dispenserTypes) {
    query.append(
      'filter.p.m.collection_filter.fil_dispenser_type',
      dispenserType,
    )
  }

  const res = await fetch(`/collections/dispensers?${query.toString()}`).then(
    (res) => res.json(),
  )
  cache.set(cacheKey, res)
  return res
}
